import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {IconButton, Layout, Popover, ScheduleIcon} from '@phonectas/unifon-ui-kit';

const ActivityPlan: React.FC = () => {
	const [t] = useTranslation();

	const planderContent = useMemo(() => {
		return (
			<Layout style={{width: '80vw', height: '600px', position: 'relative'}}>
    
			</Layout>
		);
	}, [t]);

	return (
		<>
			<Popover
				click
				content={planderContent}
				usePortal
				arrow
			>
				<IconButton size="xxl">
					<ScheduleIcon color="white" />
				</IconButton>
			</Popover>
		</>
	);
}

export default ActivityPlan;